import {
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_ID,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_TRACKING_ID,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_OBJECTIVES_WITH_DESTINATION_TYPE_META,
  ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META,
  ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_TIKTOK,
  ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_APP_OPTION,
  ADS_CAMPAIGN_TYPE_APP_OPTION,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION,
} from "../constants";

export const getMetaDefaultsFieldVisibility = ({
  objective,
  destinationType,
}) => ({
  objective: true,
  destinationType:
    ADS_CAMPAIGN_OBJECTIVES_WITH_DESTINATION_TYPE_META.includes(objective) &&
    objective !== ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  identities: true,
  appPromotion: objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  catalogID:
    destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION ||
    objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  appID:
    objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION ||
    (objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION &&
      destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_OPTION) ||
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_ID.includes(destinationType),
  trackingID:
    ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META.includes(objective) &&
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_TRACKING_ID.includes(
      destinationType
    ),
});

export const getTikTokDefaultsFieldVisibility = ({ objective, type }) => ({
  objective: true,
  type:
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION ||
    objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  appPromotion:
    objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION &&
    type === ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL_OPTION,
  identities: true,
  appID: objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  catalogID:
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION &&
    type === ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_APP_OPTION,
  trackingID: ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_TIKTOK.includes(objective),
});

export const getGoogleDefaultsFieldVisibility = ({ objective }) => ({
  objective: true,
  identities: true,
  merchantCenterID: objective === ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION,
  appID: objective === ADS_CAMPAIGN_TYPE_APP_OPTION,
});

export const LINKEDIN_DEFAULTS_FIELD_VISIBILITY = {
  objective: true,
  identities: true,
  adFormat: true,
};
